import { render, staticRenderFns } from "./ShowBins.vue?vue&type=template&id=780c5277&scoped=true"
import script from "./ShowBins.vue?vue&type=script&lang=js"
export * from "./ShowBins.vue?vue&type=script&lang=js"
import style0 from "./ShowBins.vue?vue&type=style&index=0&id=780c5277&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780c5277",
  null
  
)

export default component.exports